export default __webpack_public_path__ + "static/static-ip-97e6f867625e2a47c540c77d20586c7c.png";